module.exports = __webpack_public_path__ + "706450d7bba6374ca02fe167d86685cb.ttf";